import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Cloud_md = (props) => {
    const width = props.width ? props.width + 'px' : '24px';
    const height = props.height ? props.height + 'px' : '24px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 24 24"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.22872 8.02886C7.018 5.63988 9.25737 4 11.8059 4H12C15.3137 4 18 6.68629 18 10V10.0275C20.25 10.2762 22 12.1837 22 14.5C22 16.9853 19.9853 19 17.5 19H7.5C4.46243 19 2 16.5376 2 13.5V12.7556C2 10.3073 3.85021 8.29104 6.22872 8.02886ZM11.8059 6C10.028 6 8.47827 7.21002 8.04707 8.93484L8.02941 9.00547C7.88329 9.58996 7.35812 10 6.75564 10C5.23374 10 4 11.2337 4 12.7556V13.5C4 15.433 5.567 17 7.5 17H17.5C18.8807 17 20 15.8807 20 14.5C20 13.1193 18.8807 12 17.5 12H17C16.4477 12 16 11.5523 16 11V10C16 7.79086 14.2091 6 12 6H11.8059Z"
            />
        </SvgStyled>
    );
};

export default Cloud_md;
